import { TRUST } from "@/lib/site";

const TrustStrip = ({ variant = "light" }) => {
  const dark = variant === "dark";
  return (
    <div
      data-testid="trust-strip"
      className={`grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 ${
        dark ? "" : ""
      }`}
    >
      {TRUST.map((t) => (
        <div
          key={t.name}
          className={`flex items-center gap-3 px-4 py-4 rounded-2xl border ${
            dark
              ? "border-[var(--ss-cream)]/15 bg-[var(--ss-teal-800)]/40"
              : "border-[var(--ss-line)] bg-white/70"
          } backdrop-blur-sm`}
        >
          <span
            className={`w-11 h-11 rounded-full flex items-center justify-center shrink-0 ${
              dark
                ? "bg-[var(--ss-gold)]/15 text-[var(--ss-gold)]"
                : "bg-[var(--ss-cream)] text-[var(--ss-teal-700)]"
            }`}
          >
            <i className={`fa-solid ${t.icon}`}></i>
          </span>
          <div className="leading-tight">
            <div className={`font-semibold text-sm ${dark ? "text-[var(--ss-cream)]" : "text-[var(--ss-teal-800)]"}`}>
              {t.name}
            </div>
            <div className={`text-xs ${dark ? "text-[var(--ss-cream)]/60" : "text-[var(--ss-ink-soft)]"}`}>
              {t.sub}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default TrustStrip;
